import './csp';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.scss';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// Match generated style tags to the per-response CSP nonce. Vite development
// serves the placeholder unchanged and does not send the production CSP header.
const nonce = document.querySelector<HTMLMetaElement>(
  'meta[name="csp-nonce"]'
)?.content;
const emotionCache = createCache({
  key: 'css',
  nonce: nonce === '__CSP_NONCE__' ? undefined : nonce
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <CacheProvider value={emotionCache}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <App />
      </LocalizationProvider>
    </CacheProvider>
  </React.StrictMode>
);
